
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18.92","height":"17.58"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_46087","data-name":"Group 46087","transform":"translate(-1157.25 -467.25)","fill":"none","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"id":"Path_32442","data-name":"Path 32442","d":"M2.25 11.719A2.876 2.876 0 004.668 14.6q1.457.214 2.942.33v4.15l3.738-3.737a1.018 1.018 0 01.7-.3 43.143 43.143 0 005.208-.445 2.875 2.875 0 002.419-2.884V6.342a2.875 2.875 0 00-2.418-2.884 43.419 43.419 0 00-12.583 0A2.876 2.876 0 002.25 6.342v5.376z","transform":"translate(1155.75 465)"}}),_c('path',{attrs:{"id":"Path_32443","data-name":"Path 32443","d":"M7.5 8.25h8.04M7.5 10.93h4.02","transform":"translate(1155.19 464.44)"}})])])
          )
        }
      }
    